import {
  ReconnectingWebSocket
} from "./chunk-YV734IKE.mjs";

// src/index.ts
function generateUUID() {
  if (typeof crypto !== "undefined" && crypto.randomUUID) {
    return crypto.randomUUID();
  }
  let d = (/* @__PURE__ */ new Date()).getTime();
  let d2 = typeof performance !== "undefined" && performance.now && performance.now() * 1e3 || 0;
  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function(c) {
    let r = Math.random() * 16;
    if (d > 0) {
      r = (d + r) % 16 | 0;
      d = Math.floor(d / 16);
    } else {
      r = (d2 + r) % 16 | 0;
      d2 = Math.floor(d2 / 16);
    }
    return (c === "x" ? r : r & 3 | 8).toString(16);
  });
}
var PartySocket = class extends ReconnectingWebSocket {
  constructor(partySocketOptions) {
    const {
      host: rawHost,
      room,
      party,
      protocol,
      query,
      protocols,
      ...socketOptions
    } = partySocketOptions;
    const _pk = partySocketOptions.id || generateUUID();
    const host = rawHost.replace(/^(http|https|ws|wss):\/\//, "");
    let url = `${protocol || (host.startsWith("localhost:") || host.startsWith("127.0.0.1:") ? "ws" : "wss")}://${host}/${party ? `parties/${party}` : "party"}/${room}`;
    if (query) {
      url += `?${new URLSearchParams({ ...query, _pk }).toString()}`;
    } else {
      url += `?_pk=${_pk}`;
    }
    super(url, protocols, socketOptions);
    this.partySocketOptions = partySocketOptions;
    this._pk = _pk;
    this._pkurl = url;
    this.name = party ?? "main";
    this.room = room;
    this.host = host;
  }
  _pk;
  _pkurl;
  name;
  room;
  host;
  get id() {
    return this._pk;
  }
  // partysocket has a static url, so we can just return that
  get url() {
    return this._pkurl;
  }
};

export {
  PartySocket
};
